import React, { Component } from 'react';
import { APP_CONST } from '../../../../constants';
import { GeckoFields, ProfileList, Spinner, GeckoBtn } from '../../../../components';
import { Auth } from '../../../../services';
import ScopeSelector from './ScopeSelector';
import { GeckoToastService } from '@geckolabs/gecko-react-ui';
import { CLIENT_API } from '../../../../services/ClientManager';
import './styles.css'

const STEP_CHOOSE_PROFILE = 'step_choose_profile';
const STEP_CHOOSE_SCOPES = 'step_choose_scopes';

export class Composer extends Component {
    state = {
        step: STEP_CHOOSE_PROFILE,
        profiles: [],
        apps: {},
        accounts: {},
        loadingProfiles: false,
        loadingScopes: false,
        selectedProfile: null,
        selectedScopes: [],
        error: null,
        scopes: [],
    }

    constructor(props) {
        super(props);
        this.getProfiles = this.getProfiles.bind(this);
        this.renderProfiles = this.renderProfiles.bind(this);
        this.renderFields = this.renderFields.bind(this);
    }
   
    /* ====================

        Lifecycle

    ==================== */

    componentDidMount() {
        this.getProfiles();
    }

    /* ====================

        Methods

    ==================== */

    handleChange(name, evt) {
        this.setState({ [name]: evt });
    }

    moveToSelectScopesStep() {
        this.getScopes(this.state.selectedProfile);

        this.setState({
            step: STEP_CHOOSE_SCOPES,
        });
    }

    useProfile(profile) {
        this.setState({
            selectedProfile: profile.ProfileId,
        });
    }

    createToken() {
        return Auth.requestApiToken(this.state.name, this.state.selectedProfile, this.state.selectedScopes)
        .then(() => {
            return this.props.onCreate();
        }).catch((err) => {
            const errorMessage = (err && err.Error ? err.Error : 'Something Went Wrong');
            this.setState({ error: errorMessage });
            new GeckoToastService().error(errorMessage);
        });
    }
   
    getProfiles() {
        this.setState({
            loadingProfiles: true,
        });

        return Auth.saturate(CLIENT_API).then((data) => {
            return this.setState({
                loadingProfiles: false,
                ...data
            });
        })
        .catch((err) => {
            this.setState({ loadingProfiles: false, error: err.message });
            new GeckoToastService().error(err.message);
        });
    }

    getScopes(profileId) {
        this.setState({
            loadingScopes: true,
        });

        return Auth.listScopes(profileId).then((data) => {
            return this.setState({
                loadingScopes: false,
                scopes: data,
            });
        })
        .catch((err) => {
            this.setState({ loadingScopes: false, error: err.Error });
            new GeckoToastService().error(err.Error);
        });
    }

    toggleScope(key) {
        if (Array.isArray(key)) {
            this.setState({
                selectedScopes: key,
            });
        } else {
            if (this.state.selectedScopes.includes(key)) {
                this.setState({
                    selectedScopes: this.state.selectedScopes.filter((selectedKey) => selectedKey !== key),
                })
            } else {
                this.setState({
                    selectedScopes: this.state.selectedScopes.concat([key]),
                })
            }
        }
    }

    /* ====================

        Renders

    ==================== */

    renderProfiles() {
        if (this.state.loadingProfiles) {
            return (
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingTop: '30px'}}>
                    <Spinner />
                </div>
            );
        }

        const noProfiles = () => {
            return (
                <div className="Composer-noScopesToChoose">
                    <h2>No Profiles To Choose From</h2>
                    <h3>You don't have access to any apps that support API tokens.</h3>
                </div>
            )
        };

        return (
            <div className="Composer-ProfileList-container">
                <div className="gecko-field">
                    <label className="control-label"><span>Select A Profile</span></label>
                </div>
                <ProfileList 
                    profiles={this.state.profiles} 
                    apps={this.state.apps.byId} 
                    accounts={this.state.accounts.byId} 
                    onClick={this.useProfile.bind(this)}
                    selected={[this.state.selectedProfile]}
                    renderEmpty={noProfiles} />
            </div>
        );
    }

    renderFields() {
        const {name} = this.state;
        return (
            <GeckoFields
                fields={[{
                    label: 'API Token Name',
                    key: 'name',
                    type: APP_CONST.FIELD_TYPE_TEXT,
                    width: '100%',
                    placeholder: 'Describe what this token is for',
                }]}
                values={{name}}
                handler={this.handleChange.bind(this)}
                submitHandler={() => {}} />
        );
    }

    renderScopeSelector() {
        if (this.state.error) {
            return (
                <div className="Composer-noScopesToChoose">
                    <h2>Aww Snap!</h2>
                    <h3>Something went wrong with your request. If this keeps happening contact support for assistance.</h3>
                </div>
            )
        }

        if (this.state.loadingScopes) {
            return (
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingTop: '30px'}}>
                    <Spinner />
                </div>
            );
        }

        if (this.state.scopes.length === 0) {
            return (
                <div className="Composer-noScopesToChoose">
                    <h2>No Permissions To Choose From</h2>
                    <h3>You're API token is ready to be created</h3>
                </div>
            )
        }

        return(
            <div className="Composer-ScopeSelector-Container">
                <div className="ScopeSelector-Container-description">
                    Choose all the permissions to grant your new API token. You should only grant permissions essential to complete the specific task.
                </div>
                <div className="ScopeSelector-Container-inner">
                    <ScopeSelector scopes={this.state.scopes} selectedScopes={this.state.selectedScopes} onClick={this.toggleScope.bind(this)} />
                </div>
            </div>
        );
    }

    renderButtons() {
        const isValidProfileSelection = () => {
            if (this.state.loadingProfiles) {
                return false;
            }

            if (!this.state.name || this.state.name === '') {
                return false;
            }

            if (!this.state.selectedProfile) {
                return false;
            }

            return true;
        }

        return (
            <div className="Composer-action-buttons">
                {this.state.step === STEP_CHOOSE_PROFILE &&
                    <GeckoBtn 
                        className="pull-right" 
                        name={'Next'}
                        type={APP_CONST.BTN_TYPE_PRIMARY} 
                        handler={this.moveToSelectScopesStep.bind(this)}
                        disabledWhen={() => !isValidProfileSelection()}
                    />
                }

                {this.state.step === STEP_CHOOSE_SCOPES &&
                    <GeckoBtn 
                        className="pull-right" 
                        name={'Create'}
                        type={APP_CONST.BTN_TYPE_PRIMARY} 
                        handler={this.createToken.bind(this)}
                        disabledWhen={() => (!isValidProfileSelection() || this.state.loadingScopes || this.state.error || ( this.state.scopes.length > 0 && this.state.selectedScopes.length === 0) ? true : false)}
                    />
                }
            </div>
        );
    }

    render() {
        if (this.state.step === STEP_CHOOSE_PROFILE) {
            return (
                <>
                    {this.renderFields()}
                    {this.renderProfiles()}
                    {this.renderButtons()}
                </>
            );
        } else if (this.state.step === STEP_CHOOSE_SCOPES) {
            return (
                <>
                    {this.renderScopeSelector()}
                    {this.renderButtons()}
                </>
            )
        }

        return null;
    }
}

Composer.defaultProps = {
    onCreate: () => {},
}

export default Composer;
